import React, { useState, useContext } from 'react';

//context
import { ListContext } from '@/context/ListContext';

//components
import WidgetButton from './WidgetButton/WidgetButton';
import ModalWrapper from  '@/components/modals/ModalWrapper';
import LegacyUseExisingModal from  '@/components/modals/widgetPanel/LegacyUseExistingModal';
import { BasicTooltip } from 'thrive-components';

//enums
import { WidgetType } from  '@/interfaces/widgetPanel';



const LegacyExistingWidget = () => {
    const [showUseExistingModal, setShowExistingModal] = useState<boolean>();
    const {listId, appGuid} = useContext(ListContext)

    return (
        <BasicTooltip 
            children={
                <div className="widget-panel-item">
                    <WidgetButton type={WidgetType.EXISTING} onClick={() => setShowExistingModal(true)} />
                    
                    <ModalWrapper className='legacy-use-existing-modal' isOpen={showUseExistingModal ?? false} onRequestClose={() => setShowExistingModal(false)}>
                        <LegacyUseExisingModal hideModal={() => setShowExistingModal(false)} appGuid={appGuid} listId={listId}/>
                    </ModalWrapper>
                </div>
            } 
            className='above widget-item-tooltip'
            text={'Select an existing content item, with edits updated to all synced content items'} 
        />
    )
}
export default LegacyExistingWidget